import { render } from "./BusinessMasterList.vue?vue&type=template&id=39d53bb7&scoped=true&ts=true"
import script from "./BusinessMasterList.vue?vue&type=script&lang=ts"
export * from "./BusinessMasterList.vue?vue&type=script&lang=ts"

import "./BusinessMasterList.vue?vue&type=style&index=0&id=39d53bb7&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3687640787/src/biomass-frontend-pwc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d53bb7"]])

export default __exports__